module.exports = __webpack_public_path__ + "static/media/slika4.1bc558f3.png";